import type { ReactNode } from "react";
import { chipClassName, type ChipSize, type ChipTone } from "../styles/chipStyles";
import { classNames } from "../styles/classNames";

interface ChipProps {
  tone?: ChipTone;
  size?: ChipSize;
  /** A longer explanation, shown on hover. The chip's text itself must name the state. */
  title?: string;
  /** A small icon before the text, such as a spinner for work in progress. */
  icon?: ReactNode;
  /** Layout only (margins, shrink); the look comes from tone and size. */
  className?: string;
  children: ReactNode;
}

/**
 * A short label for a state, kind or count. Domain badges map their states to a tone and
 * render this, so every chip looks and reads the same. The state is always in the text,
 * never in the colour alone.
 */
export default function Chip({ tone = "neutral", size = "small", title, icon, className, children }: ChipProps) {
  return (
    <span className={classNames(chipClassName(tone, size), className)} title={title}>
      {icon}
      {children}
    </span>
  );
}
